import { Routes } from '@angular/router';

import {
	ADMIN_PATH,
	SHAREABLE_ELEMENTS_BASE_PATH,
	USER_PROFILE_PATH,
} from './constants';
import { roleGuard } from './core/auth/role.guard';
import { RoleType } from './core/domain/module-role';
import { DcMarketPlaceIcons } from './ui/app-marketplace-icons';

export type Feature = 'sharedElements' | 'profile' | 'admin';

export const routes: Routes = [
	{
		path: SHAREABLE_ELEMENTS_BASE_PATH,
		data: {
			featureName: 'sharedElements',
			iconName: DcMarketPlaceIcons.Share,
			isPrincipalNav: true,
			roles: [RoleType.DCV_MEMBER],
		},
		loadChildren: () =>
			import('./features/shareable-elements/shareable-elements.routes').then(
				(m) => m.SHARED_ELEMENTS_ROUTES,
			),
	},
	{
		path: USER_PROFILE_PATH,
		data: {
			featureName: 'profile',
			isPrincipalNav: false,
		},
		loadComponent: () =>
			import(
				'./features/profile/components/user-profile/user-profile.component'
			).then((c) => c.UserProfileComponent),
	},
	{
		path: `${ADMIN_PATH}`,
		data: {
			featureName: 'admin',
			iconName: DcMarketPlaceIcons.RoleMonitorLogs,
			isPrincipalNav: true,
			roles: [RoleType.DCV_ADMIN_LOG],
		},
		loadChildren: () =>
			import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
		canActivate: [roleGuard()],
	},
	{
		path: '**',
		redirectTo: SHAREABLE_ELEMENTS_BASE_PATH,
		pathMatch: 'full',
	},
];
